const appBasePath =
  import.meta.env.VITE_APP_BASE_PATH?.replace(/\/$/, "") ?? "";
const appTitle = import.meta.env.VITE_APP_TITLE ?? "GPS ERP Next";
export { appBasePath, appTitle };
